export const UNIT_OF_MEASURE_GET_REQUEST = 'UNIT_OF_MEASURE_GET_REQUEST';
export const UNIT_OF_MEASURE_GET_SUCCESS = 'UNIT_OF_MEASURE_GET_SUCCESS';
export const UNIT_OF_MEASURE_GET_ERROR = 'UNIT_OF_MEASURE_GET_ERROR';
export const UNIT_OF_MEASURE_GET_BY_KEY_REQUEST = 'UNIT_OF_MEASURE_GET_BY_KEY_REQUEST';
export const UNIT_OF_MEASURE_GET_BY_KEY_SUCCESS = 'UNIT_OF_MEASURE_GET_BY_KEY_SUCCESS';
export const UNIT_OF_MEASURE_GET_BY_KEY_ERROR = 'UNIT_OF_MEASURE_GET_BY_KEY_ERROR';
export const UNIT_OF_MEASURE_ADD_REQUEST = 'UNIT_OF_MEASURE_ADD_REQUEST';
export const UNIT_OF_MEASURE_ADD_SUCCESS = 'UNIT_OF_MEASURE_ADD_SUCCESS';
export const UNIT_OF_MEASURE_ADD_ERROR = 'UNIT_OF_MEASURE_ADD_ERROR';
export const UNIT_OF_MEASURE_EDIT_REQUEST = 'UNIT_OF_MEASURE_EDIT_REQUEST';
export const UNIT_OF_MEASURE_EDIT_SUCCESS = 'UNIT_OF_MEASURE_EDIT_SUCCESS';
export const UNIT_OF_MEASURE_EDIT_ERROR = 'UNIT_OF_MEASURE_EDIT_ERROR';
export const UNIT_OF_MEASURE_DELETE_REQUEST = 'UNIT_OF_MEASURE_DELETE_REQUEST';
export const UNIT_OF_MEASURE_DELETE_SUCCESS = 'UNIT_OF_MEASURE_DELETE_SUCCESS';
export const UNIT_OF_MEASURE_DELETE_ERROR = 'UNIT_OF_MEASURE_DELETE_ERROR';
